// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3lqud","title":"styles_title__zfeCE","image":"styles_image__30OZb"};